import { FeaturedProject } from "config"
import MetadataAwareTokenView from "components/MetadataAwareTokenView"
import PlatformBadgeRow from "components/PlatformBadgeRow"
import WorkSaleProgress from "components/WorkSaleProgress"
import { getProjectPlatformBadges } from "data/platforms"
import useProjectChainState from "hooks/useProjectChainState"

interface Props {
  project: FeaturedProject
  width?: number
}

const FeaturedProjectPreview = ({ project, width = 280 }: Props) => {
  const platformBadges = getProjectPlatformBadges(project.contractAddress, project.projectId, {
    chainId: project.chainId,
  })
  const chainState = useProjectChainState(project.contractAddress, project.projectId, project.chainId)
  const soldCount = chainState.data?.invocations ?? 0
  const totalCount = soldCount

  return (
  <a
    href={project.detailPath}
    className="gallery-card block group"
  >
    <div className="gallery-card-art">
      <div className="transition-transform duration-500 group-hover:scale-[1.015]">
        <MetadataAwareTokenView
          project={project}
          tokenId={project.sampleTokenId}
          width={width}
          fallbackAspectRatio={project.aspectRatio}
        />
      </div>
    </div>

    <div className="gallery-card-body">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="gallery-label artist-name text-gallery-muted">{project.artistName}</p>
          <h2 className="font-serif text-[1.55rem] leading-tight font-normal text-gallery-text group-hover:text-gallery-accent transition-colors duration-200">
            {project.name}
          </h2>
          <PlatformBadgeRow badges={platformBadges} interactive={false} className="mt-2" />
        </div>
        <span className="gallery-status">{project.statusLabel}</span>
      </div>

      <p className="gallery-card-description">{project.description}</p>

      <WorkSaleProgress soldCount={soldCount} totalCount={totalCount} loading={chainState.loading} />
    </div>
  </a>
  )
}

export default FeaturedProjectPreview
